"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Translated = _interopRequireDefault(require("../../Translated"));
var _internalAccount = require("../../../api/accessors/internalAccount");
var _DialogTitle = _interopRequireDefault(require("../../DialogTitle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const WarningContent = _ref => {
  let {
    account,
    onClose
  } = _ref;
  const renderMessage = () => {
    if ((0, _internalAccount.hasPastDueSubscription)(account)) {
      return /*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "subscription_past_due"
      });
    }
    if ((0, _internalAccount.hasIncompleteSubscription)(account)) {
      return /*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "subscription_incomplete"
      });
    }
    return /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "popup_warning_text"
    });
  };
  const renderTitle = () => {
    if ((0, _internalAccount.hasPastDueSubscription)(account) || (0, _internalAccount.hasIncompleteSubscription)(account)) {
      return /*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "error"
      });
    }
    return /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "membership_required"
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    onClose: onClose
  }, renderTitle()), /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, renderMessage())), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    onClick: onClose,
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "okay"
  }))));
};
var _default = exports.default = WarningContent;